import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// 🔹 Removed BrowserRouter import from here since it's now in App.js

// ----------------- Prevent stale alerts / cached JS -----------------
if (process.env.NODE_ENV === "development") {
  const meta = document.createElement("meta");
  meta.httpEquiv = "Cache-Control";
  meta.content = "no-cache, no-store, must-revalidate";
  document.getElementsByTagName("head")[0].appendChild(meta);

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      for (let registration of registrations) {
        registration.unregister();
      }
    });
  }
}
// ---------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 🔹 Removed <BrowserRouter> from here to avoid the "Double Router" error */}
    <App />
  </React.StrictMode>
);

reportWebVitals();